import { useShallow } from 'zustand/shallow';
import { CandidateSelectionState, store } from './store';

export const useCandidateSelection = () => {
  const {
    viewMode,
    toggleViewMode,
    selectId,
    selectAll,
    unSelectId,
    selectedIds,
    selectionMode,
    toggleSelectAll,
    deselectAll,
  } = store<CandidateSelectionState>(
    useShallow((state) => ({
      selectedIds: state.selectedIds,
      selectId: state.selectId,
      unSelectId: state.unSelectId,
      viewMode: state.viewMode,
      toggleViewMode: state.toggleViewMode,
      selectionMode: state.selectionMode,
      selectAll: state.selectAll,
      deselectAll: state.deselectAll,
      toggleSelectAll: state.toggleSelectAll,
    })),
  );

  return {
    viewMode,
    toggleViewMode,
    selectId,
    selectAll,
    unSelectId,
    selectedIds,
    selectionMode,
    toggleSelectAll,
    deselectAll,
  };
};
